import {
  LayoutDashboard,
  Users,
  FileStack,
  Gauge,
  Landmark,
  Building2,
  Bot,
  ListOrdered,
  Send,
  GitBranch,
  DollarSign,
  BarChart3,
  FolderOpen,
  Settings,
} from 'lucide-react';

export const FUNDGENIUS_PRIMARY_NAV = [
  { id: 'dashboard', label: 'Dashboard', segment: '', icon: LayoutDashboard },
  {
    id: 'clients',
    label: 'Clients',
    segment: 'clients',
    icon: Users,
    children: [
      { id: 'client-roster', label: 'Client roster', segment: 'clients' },
    ],
  },
  { id: 'profiles', label: 'Funding Profiles', segment: 'profiles', icon: FileStack },
  { id: 'readiness', label: 'Readiness', segment: 'readiness', icon: Gauge },
  { id: 'advisor', label: 'AI Advisor', segment: 'ai-advisor', icon: Bot },
  { id: 'match', label: 'Bank Match', segment: 'match', icon: Landmark },
  { id: 'lenders', label: 'Lenders', segment: 'lenders', icon: Building2 },
  { id: 'submissions', label: 'Submissions', segment: 'submissions', icon: Send },
  { id: 'pipeline', label: 'Pipeline', segment: 'pipeline', icon: GitBranch },
  { id: 'commissions', label: 'Commissions', segment: 'commissions', icon: DollarSign },
  { id: 'reports', label: 'Reports', segment: 'reports', icon: BarChart3 },
  { id: 'documents', label: 'Documents', segment: 'documents', icon: FolderOpen },
  { id: 'sequence', label: 'Sequence', segment: 'sequence', icon: ListOrdered },
  { id: 'settings', label: 'Settings', segment: 'settings', icon: Settings },
];
